export default {
  namespaced: true,
  state: {
    username: null,
    companyName: null,
  },
  getters: {
    username(state) {
      return state.username
    },
    companyName(state) {
      return state.companyName
    },
  },
  mutations: {
    setUsername(state, $) {
      state.username = $
    },
    setCompanyName(state, $) {
      state.companyName = $
    },
  },
  actions: {},
}



// WEBPACK FOOTER //
// ./src/legacy/store/modules/questionnaries.js